<template lang="pug">
div(class="flex items-center")
    div(v-if="showLikeCount && build.likes > 0") {{ build.likes }}

    button(
        class="p-1 w-8 h-8 ml-2 inline-flex justify-center items-center rounded-full border-2 border-primary"
        :class="{ 'border-transparent text-gray-darkest bg-primary hover:bg-primary-dark': hasLiked, 'text-primary hover:bg-gray-darker': !hasLiked }"
        @click.prevent="like"
    )
        LikedIcon(class="w-6 h-6")
    button(
        v-if="canUseShareApi"
        class="p-1 w-8 h-8 ml-2 inline-flex justify-center items-center rounded-full border-2 border-primary text-primary hover:bg-gray-darker"
        @click.prevent="share"
    )
        ShareIcon(class="w-6 h-6")
</template>

<script>
import ShareIcon from '@/assets/common/share?inline'
import LikedIcon from '@/assets/common/thumbsUp?inline'

export default {
    name: 'LikeAndShare',
    components: { ShareIcon, LikedIcon },
    inject: ['liked', 'saveLocalLike'],
    props: {
        build: {
            type: Object,
            default: () => {},
        },
        showLikeCount: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            canUseShareApi: false,
        }
    },
    computed: {
        hasLiked() {
            return this.liked.builds.includes(this.buildId)
        },
        buildId() {
            return this.build.objectID || this.build.id
        },
    },
    mounted() {
        this.canUseShareApi = navigator.canShare
    },
    methods: {
        like() {
            if (!this.hasLiked) {
                this.saveLocalLike(this.buildId)
                this.postLike()
            }
        },
        postLike() {
            return this.$axios.post(`${this.$config.platform.apis.builds}${this.buildId}/like`, {
                id: this.buildId,
            })
        },
        share() {
            if (this.canUseShareApi) {
                navigator.share({
                    title: this.build.title,
                    url: `https://${window.location.hostname}/builds/${this.buildId}`,
                    text: this.build.description,
                })
            }
        },
    },
}
</script>
